import * as React from 'react';
import DateTimeView, { LocalDateTime } from '../../../../../features/localDate/DateTimeView';
import { ButtonGroup, Button, Row, Col } from 'react-bootstrap';

interface IProps {
    showSingleMessage?: boolean;
    returnedMessages: {
        returnedMessage: string;
        returnedDate: LocalDateTime;
    }[];
    title: any;
}

interface IState {
    selectedMessage: number;
    returnedMessages: { returnedMessage: string; returnedDate: any }[];
}

class ReturnedMessageText extends React.Component<IProps, IState> {
    constructor(props: IProps, context: any) {
        super(props, context);

        this.state = {
            selectedMessage: 0,
            returnedMessages: [
                {
                    returnedMessage: '',
                    returnedDate: ''
                }
            ]
        };

        this.incrementSelectedMessage = this.incrementSelectedMessage.bind(this);
        this.decrementSelectedMessage = this.decrementSelectedMessage.bind(this);
    }

    componentDidMount() {
        this.setState({
            returnedMessages: this.props.returnedMessages,
            selectedMessage: this.props.returnedMessages.length - 1
        } as IState);
    }

    incrementSelectedMessage(e: any) {
        let selectedMessage = this.state.selectedMessage;
        selectedMessage++;
        selectedMessage =
            selectedMessage >= this.state.returnedMessages.length ? 0 : selectedMessage;
        this.setState({ selectedMessage: selectedMessage } as IState);
    }

    decrementSelectedMessage(e: any) {
        let selectedMessage = this.state.selectedMessage;
        selectedMessage--;
        selectedMessage =
            selectedMessage < 0 ? this.state.returnedMessages.length - 1 : selectedMessage;
        this.setState({ selectedMessage: selectedMessage } as IState);
    }

    render() {
        return (
            <div>
                {this.props.showSingleMessage && (
                    <div>
                        <Row className="plan-return-message-buttons">
                            <Col xs={8}>
                                {this.props.title} ({this.state.selectedMessage + 1}/
                                {this.state.returnedMessages.length})
                            </Col>
                            <Col xs={4}>
                                <ButtonGroup className="pull-right">
                                    <Button bsSize="xs" onClick={this.decrementSelectedMessage}>
                                        <i className="material-icons">keyboard_arrow_down</i>
                                    </Button>
                                    <Button bsSize="xs" onClick={this.incrementSelectedMessage}>
                                        <i className="material-icons">keyboard_arrow_up</i>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <i>
                            <DateTimeView
                                dateTime={
                                    this.state.returnedMessages[this.state.selectedMessage]
                                        .returnedDate
                                }
                            />
                        </i>
                        <p>
                            {
                                this.state.returnedMessages[this.state.selectedMessage]
                                    .returnedMessage
                            }
                        </p>
                    </div>
                )}
                {!this.props.showSingleMessage && (
                    <dl>
                        {this.props.returnedMessages.map((message, i) => (
                            <dd key={i}>
                                <DateTimeView key={i} dateTime={message.returnedDate} />:{' '}
                                {message.returnedMessage}
                            </dd>
                        ))}
                    </dl>
                )}
            </div>
        );
    }
}

export default ReturnedMessageText;
